import { render, staticRenderFns } from "./modalDeleteUnidades.vue?vue&type=template&id=23595031&scoped=true&"
import script from "./modalDeleteUnidades.vue?vue&type=script&lang=js&"
export * from "./modalDeleteUnidades.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=23595031&scoped=true&lang=css&"
import style1 from "./modalDeleteUnidades.vue?vue&type=style&index=1&id=23595031&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23595031",
  null
  
)

export default component.exports